import { resolveComponentName } from "./resolveComponentName";

const messageComponentTagNameRegex = /\{%-?\s*message_component\s+(?:'([^']*)'|"([^"]*)"|((?:\w+)(?:\s+\w+)*))/g;
const exactMessageComponentTagRegex = new RegExp(`^${messageComponentTagNameRegex.source}\\s*-?%\\}$`);

export const extractLiquidMessageComponentNames = (...texts: string[]) => {
  return texts.reduce((acc, text) => {
    if (!text) {
      // short-circuit against nulls or undefineds
      return acc;
    }

    for (const match of text.matchAll(messageComponentTagNameRegex)) {
      // index 0 is the entire matched string, and the rest are the or'ed inner texts between quotes (if applicable)
      const name = match[1] || match[2] || match[3];
      if (name && name.length > 0) {
        acc.add(name);
      }
    }
    return acc;
  }, new Set<string>());
};

/** Checks whether a value contains only the requested message_component Liquid tag. */
export const isExactLiquidMessageComponentTag = (
  value: string | null | undefined,
  componentName: string
): boolean => {
  if (typeof value !== "string" || !exactMessageComponentTagRegex.test(value.trim())) {
    return false;
  }

  const [liquidComponentName] = extractLiquidMessageComponentNames(value);
  return !!liquidComponentName && !!resolveComponentName(liquidComponentName, [componentName]);
};
